<template>
  <div>
    <div class="black-overlay"></div>
    <div :class="['modal', 'modal--postfreegame', determineWinnerCSSClass]" id="welcome_modal">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header">
          <h1>{{ gameWinnerMSISDN === 'trial user' ? getTranslations.home_modals_post_game_congratz : getTranslations.home_modals_post_game_too_bad }}
            <br>{{ gameWinnerMSISDN === 'trial user' ? getTranslations.home_modals_post_you_won_the_game : getTranslations.home_modals_post_you_lost_the_game }}</h1>
          <ul>
            <li>
              <img :src="playersDetails.homePlayerAvatar" alt="">
              <span class="name">{{ playersDetails.homePlayerUsername }}</span>
            </li>
            <li class="trophy">
              <img src="/static/images/trophy.png" alt="">
              <div class="score"><span>{{ homeScore }}</span>-<span>{{ awayScore }}</span></div>
            </li>
            <li>
              <img :src="playersDetails.awayPlayerAvatar" alt="">
              <span class="name">{{ playersDetails.awayPlayerUsername }}</span>
            </li>
          </ul>
        </div>
        <div class="modal__body">
          <h3>{{ getTranslations.home_modals_post_game_bonus_points_earned }}</h3>
          <ul class="buttons">
            <li><span class="score-lbl">{{ correctAnswersPoints }}</span><span class="title">{{ getTranslations.home_modals_post_game_correct_answers }}</span></li>
            <li><span class="score-lbl" style="background: #aa4225">{{ gameVictoryPoints }}</span><span class="title">{{ getTranslations.home_modals_post_game_game_victory }}</span></li>
            <li><span class="score-lbl" style="background: #16a085">{{ totalEarnedPoints }}</span><span class="title">{{ getTranslations.home_modals_post_game_total_earned }}</span></li>
          </ul>
        </div>
        <div class="modal__footer">
          <a @click.prevent="savePoints()" class="btn2 btn2--std btn2--small" style="cursor:pointer">{{ getTranslations.visitor_free_trial_save_score }}</a>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters, mapState, mapMutations } from 'vuex';

export default {
  name: 'postGameFreePlay',
  data() {
    return {
      correctAnswersPoints: 0,
      gameVictoryPoints: 0,
      totalEarnedPoints: 0,
      homeScore: 0,
      awayScore: 0,
    };
  },
  created() {
    console.log('in PostGame created hook:');
    this.correctAnswersPoints = this.homePlayerRoundScore * 100;
    if (this.gameWinnerMSISDN === 'trial user') {
      this.homeScore = 1;
      this.gameVictoryPoints = 200;
    } else {
      this.awayScore = 1;
    }
    this.totalEarnedPoints = this.correctAnswersPoints + this.gameVictoryPoints;
  },
  methods: {
    ...mapMutations('game', [
      'storeRegistrationPoints',
    ]),
    goToRegistration() {
      this.$router.push('/register1');
    },
    savePoints() {
      this.storeRegistrationPoints({
        correctPoints: this.correctAnswersPoints,
        victoryPoints: this.gameVictoryPoints,
        totalPoints: this.totalEarnedPoints,
      });
      this.goToRegistration();
    },
  },
  computed: {
    ...mapState('game', [
      'playersDetails',
      'homePlayerRoundScore',
      'awayPlayerRoundScore',
      'gameWinnerMSISDN',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'isEqualAmountOfCorrectAnswers',
    ]),
    determineWinnerCSSClass() {
      return (this.gameWinnerMSISDN === 'trial user') ? 'player1' : 'player2';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/freeTrial/modals/PostGameFreePlay.vue